/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Municipality } from '../../models/municipality';

export interface GetMunicipality$Params {
  id: string;
}

export function getMunicipality(http: HttpClient, rootUrl: string, params: GetMunicipality$Params, context?: HttpContext): Observable<StrictHttpResponse<Municipality>> {
  const rb = new RequestBuilder(rootUrl, getMunicipality.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Municipality>;
    })
  );
}

getMunicipality.PATH = '/municipality/{id}';
